import React from 'react';
import { Environment } from 'global/environment';
import { setAuthProvider } from 'utils/auth';

export const IdMeButton: React.FC = () => {
  const redirectToIdMeAuthentication = (): void => {
    setAuthProvider('idme');
    const authorizeUrl = new URL(Environment.IDME_AUTHORIZATION_ENDPOINT || '');
    authorizeUrl.searchParams.set(
      'client_id',
      Environment.IDME_CLIENT_ID || ''
    );
    authorizeUrl.searchParams.set(
      'redirect_uri',
      Environment.IDME_REDIRECT_URI || ''
    );
    authorizeUrl.searchParams.set(
      'response_type',
      Environment.IDME_RESPONSE_TYPE || ''
    );
    authorizeUrl.searchParams.set('scope', Environment.IDME_SCOPE || '');

    window.location.href = authorizeUrl.toString();
  };
  return (
    <button
      onClick={redirectToIdMeAuthentication}
      data-test-id="IS-login-idme-button"
      style={{
        border: 'none',
        background: 'transparent',
        padding: 0,
        cursor: 'pointer',
        width: '100%',
      }}
    >
      <img
        src="https://s3.amazonaws.com/idme/developer/idme-buttons/assets/img/signin.svg"
        alt="Sign in with ID.me"
        style={{ height: '48px' }}
      />
    </button>
  );
};
